import React from 'react';
import Page from 'components/page/page';

const HelpScreen = (): JSX.Element => {
    return <Page title="Help">Help content</Page>;
};

export default HelpScreen;
